<template>
    <div class="position-relative btn-cover">
        <b-button class="ml-1 mr-1" variant="light" @click="open=!open">
            {{ value }}
        </b-button>
        <div v-show="open" class="position-absolute card card-div" tabindex="-1" @mousedown="eventPrevent">
            <div v-for="(item,i) of options" :key="i"
                 class="view-item text-center"
                 :class="item===localValue?'view-item-active':''"
                 @click="select(item)">
                <div class="m-auto">
                    {{ item }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BtnSelect",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: null,
        options: Array,
    },
    data() {
        return {
            localValue: this.value,
            open: false,
        }
    },
    watch: {
        localValue() {
            this.$emit('update:value', this.localValue);
            this.$emit('change', this.localValue);
        },
        value: {
            handler() {
                this.localValue = this.value;
            },
            immediate: true
        }
    },
    methods: {
        eventPrevent(event) {
            event.preventDefault();
        },
        select(item) {
            this.localValue = item;
            this.open = false;
        },
    }
}
</script>

<style scoped>
.btn-cover {
    width: max-content;
}

.card-div {
    top: 100%;
    left: 0;
    height: min-content;
    width: max-content;
    z-index: 1000;
    background-color: #FFFFFF;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.view-item {
    cursor: pointer;
    height: 1.5rem;
    padding: .17rem .4rem;
}

.view-item:hover {
    background-color: #f1f4f6;
}

.view-item-active {
    background-color: #c1e4fe !important;
}
</style>
